import axios from "../auth/FetchInterceptor";

const StatisticService = {};

StatisticService.getStatistics = async function (params) {
    const response = await axios.get(`/statistiques`, { params });
    return response.data;
};

StatisticService.getAnnouncementsStats = async function (params) {
    const response = await axios.get(`/announcements/stats`, { params });
    return response.data;
};

StatisticService.getDisputesStats = async function (params) {
    const response = await axios.get(`/disputes/stats`, { params });
    return response.data;
};

StatisticService.getReportsStats = async function (params) {
    const response = await axios.get(`/reports/stats`, { params });
    return response.data;
};

StatisticService.searchAnnouncements = async function (query) {
    const response = await axios.get(`/announcements/search-titles`, { params: { query } });
    return response.data;
};

StatisticService.searchDisputes = async function (query) {
    const response = await axios.get(`/disputes/search-titles`, { params: { query } });
    return response.data;
};

StatisticService.searchReports = async function (query) {
    const response = await axios.get(`/reports/search-titles`, { params: { query } });
    return response.data;
};

export default StatisticService;
